/**
 * @generated SignedSource<<44871a26b3f7345910cce5a97abfad7f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type itemLiveArticleTimelineLiveContent$data = {
  readonly customTime: number | null | undefined;
  readonly entityUuid: string;
  readonly title: string | null | undefined;
  readonly " $fragmentType": "itemLiveArticleTimelineLiveContent";
};
export type itemLiveArticleTimelineLiveContent$key = {
  readonly " $data"?: itemLiveArticleTimelineLiveContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"itemLiveArticleTimelineLiveContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "itemLiveArticleTimelineLiveContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityUuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "LiveContent",
  "abstractKey": null
};

(node as any).hash = "35576975a6014c435b11dc1c336f3012";

export default node;
